import React from 'react';

// Shared "jump to a related page" grid. Two duplicated patterns existed
// across the door hub pages: a 3-col icon+title+desc grid ("Related
// Resources") and a denser 4-col icon+label grid ("Quick Resources") —
// each hub re-implemented both with slightly different, uncoordinated icon
// colors. Icons are unified on the single brand color here.
export const ResourceLinkGrid = ({ title, items, setPage, dense = false, className = '' }) => (
  <div className={`bg-gray-50 rounded-xl p-6 ${className}`}>
    {title && <h3 className="font-bold text-gray-800 mb-4">{title}</h3>}
    <div className={dense ? 'grid grid-cols-2 md:grid-cols-4 gap-3' : 'grid grid-cols-1 md:grid-cols-3 gap-3'}>
      {items.map((item, idx) => (
        <button
          key={idx}
          onClick={() => setPage(item.page)}
          className={
            dense
              ? 'flex items-center gap-2 p-3 bg-white rounded-lg hover:shadow-md transition-all text-left'
              : 'flex items-center gap-3 p-4 bg-white rounded-lg hover:shadow-md transition-all text-left'
          }
        >
          <item.icon className={dense ? 'w-6 h-6 text-brand-600 flex-shrink-0' : 'w-8 h-8 text-brand-600 flex-shrink-0'} />
          {dense ? (
            <span className="font-medium text-gray-800 text-sm">{item.title}</span>
          ) : (
            <div className="min-w-0">
              <div className="font-semibold text-gray-800">{item.title}</div>
              {item.desc && <div className="text-sm text-gray-500">{item.desc}</div>}
            </div>
          )}
        </button>
      ))}
    </div>
  </div>
);

export default ResourceLinkGrid;
